// 账户设置路由
const accountManage = {
    path: '',
    component: () => import('@/components/RouterView'),
    meta: {title: '账户设置'},
    redirect: '/manage/dashboard',
    children: [
        {
            path: 'accountManage',
            component: () => import('@/views/manage/accountManage/account'),
            meta: {title: '账号管理'},
        },
        {
            path: 'maininfo',
            component: () => import('@/views/manage/accountManage/mainInfo'),
            meta: {title: '基本信息'},
        },
        {
            path: 'bankinfo',
            component: () => import('@/views/manage/accountManage/bankInfo'),
            meta: {title: '收款账号'},
        },
        {
            path: 'invitation',
            component: () => import('@/views/manage/accountManage/invitation'),
            meta: {title: '邀请信息'},
        },
        {
            path: 'authorize',
            component: () => import('@/views/manage/accountManage/authorize'),
            meta: {title: '授权管理'},
        },
        {
            path: 'contractdetails',
            component: () => import('@/views/manage/accountManage/contract/list'),
            meta: {title: '合同管理'},
        },
        {
            path: 'contractauthorizationdetail',
            component: () => import('@/views/manage/accountManage/contract/detail'),
            meta: {title: '合同详情'},
        },
        {
            path: 'updateAdmin',
            component: () => import('@/views/manage/accountManage/account/updateAdmin'),
            meta: {title: '更改管理员'},
        },
    ],
};

export default accountManage;
